<ng-container *ngIf="vo$ | async; let vo">
	<app-page>
		<app-page-actions class="page-actions">
			<button
				id="{{ cmpId }}-save-btn"
				class="page-actions__btn"
				[color]="'primary'"
				[disabled]="!projectAdminMapping.size"
				(click)="save(vo.list.elements.size !== projectAdminMapping.size)"
				mat-raised-button>
				<mat-icon [svgIcon]="DcIcons.Save"></mat-icon>
				<span i18n="@@general.action.save">Save</span>
			</button>
		</app-page-actions>

		<app-page-content>
			<ng-container *ngIf="vo.isLoading">
				<mat-spinner [diameter]="50"></mat-spinner>
			</ng-container>

			<div class="app-orphan-project-list__content">
				<span
					*ngIf="!vo.list.elements.size"
					i18n="@@orphan-project.mapping.no-project-info">
					no orphan projects
				</span>

<!--				<span *ngIf="vo.list.elements.size">-->
<!--									{{ projectsSummary }}-->
<!--				</span>-->

				<app-panel
					headerHeight="3rem"
					isAlwaysOpen="true"
					hasSearchableGrid="true"
					hasRefresh="true"
					maxActionsCount="6"
					[itemsCount]="vo.list.elements.size"
					[actions]="panelActions"
					[actionsAvailable]="toggleActions"
					(refresh)="refresh()"
					(search)="search($event)">
					<div panel-title class="app-panel__title">
						<span i18n="@@orphan.projects">Orphan projects</span>
					</div>
					<div panel-info class="app-orphan-project-list__panel-info">
						<div *ngIf="selectionCount">
							<span>{{ selectionCount }} &#32;</span>
							<span i18n="@@orphan-project.list.selected-elements">
								Elements selectionnée
							</span>
						</div>
						<div
							*ngIf="vo.list.elements.size !== projectAdminMapping.size"
							class="unmapped-projects-alert warn">
							<mat-icon [svgIcon]="DcIcons.Warning"></mat-icon>
							<span i18n="@@orphan-project.list.warning.unmapped-projects">
								unmapped projects
							</span>
						</div>
					</div>
					<dx-data-grid
						keyExpr="id"
						[elementAttr]="{
							id: 'orphan-project-list',
							class: 'app-orphan-project-list'
						}"
						[dataSource]="vo.list.elements | toArray"
						[hoverStateEnabled]="true"
						[showColumnHeaders]="true"
						[repaintChangesOnly]="true"
						[allowColumnResizing]="false"
						[columnAutoWidth]="false"
						[showRowLines]="false"
						[showColumnLines]="false"
						[rowAlternationEnabled]="false"
						[showBorders]="false"
						[width]="'100%'"
						(onSelectionChanged)="onGridSelectionChange($event)">
						<dxo-selection
							mode="multiple"
							showCheckBoxesMode="always"></dxo-selection>

						<dxo-header-filter [visible]="true"></dxo-header-filter>

						<dxo-load-panel
							shadingColor="rgba(0,0,0,0)"
							[indicatorSrc]="DcLoaders.LoaderInfinite"
							[height]="100"
							[width]="100"
							[enabled]="vo.isFirstLoad"
							[showIndicator]="true"
							[showPane]="true"
							[shading]="true"></dxo-load-panel>

						<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

						<ng-container
							*ngFor="let col of vo.list.availableColumns | toArray">
							<dxi-column
								*ngIf="col.field === 'label'"
								[dataField]="col.field"
								[dataType]="col.type"
								[caption]="col.alias"
								[groupIndex]="col.groupIdx"
								[fixed]="false"
								[allowResizing]="true"
								[allowHiding]="true"
								[allowGrouping]="true"
								[visible]="col.visible"
								[allowSearch]="col.isSearchable"
								[allowFiltering]="col.isFilterable"
								[allowSorting]="true"
								[format]="col.format"
								[alignment]="'left'"
								[visibleIndex]="col.visibleIndex"
								[filterValue]="col.filterValue"
								[filterValues]="col.filterValues"
								[sortIndex]="col.sortIndex"
								[sortOrder]="col.sortOrder"
								[allowHeaderFiltering]="col.hasHeaderFilter"></dxi-column>
							<dxi-column
								*ngIf="col.field === 'tags'"
								[dataField]="col.field"
								[caption]="col.alias"
								[groupIndex]="col.groupIdx"
								[fixed]="false"
								[allowResizing]="true"
								[allowHiding]="true"
								[allowGrouping]="true"
								[visible]="col.visible"
								[allowSearch]="col.isSearchable"
								[allowFiltering]="col.isFilterable"
								[allowSorting]="false"
								[format]="col.format"
								[alignment]="'left'"
								[visibleIndex]="col.visibleIndex"
								[allowHeaderFiltering]="col.hasHeaderFilter"
								[dataType]="col.type"
								[filterOperations]="[DxOperations.Contains, DxOperations.In]"
								[calculateFilterExpression]="
									calculateTagsHeaderFilterExpression
								"
								[filterValue]="col.filterValue"
								[filterValues]="col.filterValues"
								[sortIndex]="col.sortIndex"
								[sortOrder]="col.sortOrder"
								cellTemplate="tagsTemplate">
								<dxo-header-filter
									[dataSource]="tagsHeaderFilter"></dxo-header-filter>
							</dxi-column>

							<dxi-column
								*ngIf="col.field === 'adminId'"
								[dataField]="col.field"
								[caption]="col.alias"
								[groupIndex]="col.groupIdx"
								[fixed]="false"
								[allowResizing]="true"
								[allowHiding]="true"
								[allowGrouping]="true"
								[allowSearch]="col.isSearchable"
								[allowFiltering]="col.isFilterable"
								[allowSorting]="false"
								[alignment]="'left'"
								[visibleIndex]="col.visibleIndex"
								[dataType]="col.type"
								[format]="col.format"
								[visible]="col.visible"
								[filterValue]="col.filterValue"
								[filterValues]="col.filterValues"
								[sortIndex]="col.sortIndex"
								[sortOrder]="col.sortOrder"
								cellTemplate="adminsTemplate"></dxi-column>
						</ng-container>

						<div
							class="admins-template"
							*dxTemplate="let cell of 'adminsTemplate'">
							<dx-select-box
								[dataSource]="vo.admins | toArray"
								valueExpr="id"
								displayExpr="name"
								[searchEnabled]="true"
								[showClearButton]="true"
								[value]="projectAdminMapping.get(cell.key)"
								(onValueChanged)="
									onAdminSelectionChange(cell.key, $event)
								"></dx-select-box>
						</div>

						<div *dxTemplate="let cell of 'tagsTemplate'">
							<app-tag-configurator
								*ngIf="cell.data['tags'].length !== 0"
								displayMode="tags"
								configMode="View"
								[configuredTags]="cell.data['tags']"></app-tag-configurator>
						</div>

						<dxo-group-panel [visible]="true"></dxo-group-panel>

						<!-- Filterable columns	-->
						<dxo-filter-row
							[visible]="vo.list.elements.size !== 0"></dxo-filter-row>

						<!-- Sorting	-->
						<dxo-sorting mode="multiple"></dxo-sorting>

						<!-- Pagination -->
						<dxo-paging [pageSize]="50"></dxo-paging>

						<dxo-column-chooser
							[allowSearch]="true"
							[enabled]="false"
							[mode]="'select'">
							<dxo-selection
								[allowSelectAll]="true"
								[recursive]="false"></dxo-selection>
						</dxo-column-chooser>

						<dxo-filter-panel [visible]="true"></dxo-filter-panel>

						<!-- State persistence	-->
						<dxo-state-storing
							type="custom"
							[enabled]="true"
							[savingTimeout]="160"
							[customLoad]="loadState"
							[customSave]="saveState"></dxo-state-storing>
					</dx-data-grid>
				</app-panel>
			</div>
		</app-page-content>
	</app-page>
</ng-container>
